_ = require 'underscore'
Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
{ track } = require '@trello/analytics'
Label = require 'app/scripts/models/label'
labelTemplate = require 'app/scripts/views/templates/label'
cardDetailAddButtonTemplate = require 'app/scripts/views/templates/card_detail_add_button'

module.exports.openLabelsPopOver = (elem, options) ->
  PopOver.toggle
    elem: elem
    view: CardLabelSelectView
    options: _.extend({ @model, @modelCache }, options)
  return

module.exports.editLabelsMainSingleLabel = (e) ->
  Util.stop(e)
  @openLabelsPopOver(@$(e.target).closest('.card-label'))
  track("Card Detail", "Edit Labels Main Column - Single Label", undefined, @model.trackProperty())
  return

module.exports.editLabelsMain = (e) ->
  Util.stop(e)
  @openLabelsPopOver(@$('.js-details-edit-labels'))
  track("Card Detail", "Edit Labels Main Column - Plus Button", undefined, @model.trackProperty())
  return

module.exports.editLabelsSidebar = (e) ->
  Util.stop(e)
  track("Card Detail", "Sidebar", "Edit Labels Button", @model.trackProperty())
  @_openEditLabelsSidebar()

module.exports.renderLabels = ->
  activeLabels = @model.getLabels().sort(Label.compare)

  $labels = @$('.js-card-detail-labels-list').empty()

  labelsHtml = for label in activeLabels
    data = @model.dataForLabel(label)
    data.extraClasses = ['mod-card-detail']
    if @model.editable()
      data.extraClasses.push('mod-clickable')
    labelTemplate(data)

  $labels.append(labelsHtml)

  if @model.editable()
    $labels
    .append(cardDetailAddButtonTemplate(klass: 'js-details-edit-labels'))
    .addClass('js-edit-label')

  @$('.js-card-detail-labels').toggleClass('hide', activeLabels.length == 0)

  @

module.exports._openEditLabelsSidebar = (options) ->
  @openLabelsPopOver(@$('.js-edit-labels'), options)
